"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _storeStatistics = require("@/api/order/storeStatistics");
var _shopList = require("@/api/shop/shopList");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "明细统计",
  components: {},
  data: function data() {
    return {
      // 搜索表单数据
      searchForm: {
        regTimeRange: "",
        timeStart: "",
        timeEnd: "",
        storeIds: []
      },
      storeList: [],
      // 高级筛选显示状态
      showAdvanced: false,
      // 表格数据
      saleDetailData: [],
      // 加载状态
      loading: false,
      // 标签页相关
      activeTab: "list",
      // 当前激活的标签页
      editTabs: [],
      // 编辑标签页列表
      tabIndex: 0,
      // 标签页索引计数器
      imgPath: process.env.VUE_APP_IMAGE_PATH // 图片路径
    };
  },
  methods: {
    // 搜索功能
    handleSearch: function handleSearch() {
      // 验证时间跨度
      if (this.searchForm.regTimeRange && this.searchForm.regTimeRange.length === 2) {
        var startTime = new Date(this.searchForm.regTimeRange[0]);
        var endTime = new Date(this.searchForm.regTimeRange[1]);
        var diffTime = endTime - startTime;
        var diffDays = diffTime / (1000 * 60 * 60 * 24);
        if (diffDays > 31) {
          this.$message.warning('时间跨度不能超过 31 天');
          return;
        }
      }
      this.getOrderSaleDetail();
    },
    //获取信息
    getOrderSaleDetail: function () {
      var _getOrderSaleDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              data = {}; // 处理时间范围数据
              if (this.searchForm.regTimeRange && this.searchForm.regTimeRange.length === 2) {
                data.timeStart = this.searchForm.regTimeRange[0];
                data.timeEnd = this.searchForm.regTimeRange[1];
              }
              if (this.searchForm.storeIds && this.searchForm.storeIds.length > 0) {
                data.storeIds = this.searchForm.storeIds;
              }
              _context.next = 2;
              return (0, _storeStatistics.getOrderSaleStsList)(data);
            case 2:
              response = _context.sent;
              if (response.code === 200) {
                this.saleDetailData = response.data || {};
              } else {
                this.$message.error(response.message || "获取失败");
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
            case 4:
              _context.prev = 4;
              this.loading = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getOrderSaleDetail() {
        return _getOrderSaleDetail.apply(this, arguments);
      }
      return getOrderSaleDetail;
    }(),
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return "";
      return parseTime(time, "{y}-{m}-{d} {h}:{i}:{s}");
    },
    // 格式化金额
    formatAmount: function formatAmount(amount) {
      if (!amount && amount !== 0) {
        return '0.00';
      }
      return Number(amount).toFixed(2);
    },
    // 表格合计行方法
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
        data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = null;
          return;
        }
        if (index === 1) {
          sums[index] = '合计';
          return;
        }
        var key = column.property;
        if (key && ['totalOrder', 'dineInOrder', 'pickUpOrder', 'takeoutOrder'].includes(key)) {
          var values = data.map(function (item) {
            return Number(item[key]) || 0;
          });
          sums[index] = values.reduce(function (prev, curr) {
            return prev + curr;
          }, 0);
        } else if (key && ['totalAmount', 'totalTaxAmount', 'totalAvgPrice', 'totalRefundAmount', 'dineInAmount', 'dineInTaxAmount', 'dineInAvgPrice', 'pickUpAmount', 'pickUpTaxAmount', 'pickUpAvgPrice', 'takeoutAmount', 'takeoutTaxAmount', 'takeoutAvgPrice'].includes(key)) {
          var _values = data.map(function (item) {
            return Number(item[key]) || 0;
          });
          var sum = _values.reduce(function (prev, curr) {
            return prev + curr;
          }, 0);
          sums[index] = sum.toFixed(2);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    }
  },
  created: function created() {
    var _this = this;
    this.getOrderSaleDetail();
    (0, _shopList.getStoreData)().then(function (res) {
      _this.storeList = res.records;
    });
  },
  mounted: function mounted() {
    // 初始化时获取会员列表数据
  },
  watch: {}
};